import React, { useEffect } from 'react';

import { showModal } from 'modal.react.js';

import { User } from '../channels/types';
import UserBubbles from '../components/Pages/Admin/ItinerariesItemBuilder/ActionButtons/UserBubbles';
import ChangesDetectedModal from '../components/Pages/Admin/shared/Modals/ChangesDetectedModal';
import useMultipleTabsModal from '../components/Pages/Admin/shared/Modals/MultipleTabsModal/functions';
import styles from '../components/shared/ActionButtons/index.module.css';
import area from '../components/shared/GlobalModalArea/area';
import { useItinerariesItemContext } from '../utils/itineraries/context';
import { IProposal } from '../utils/itineraryDetails/types';
import useMediaBreakpoints from './useMediaBreakpoints';

export const useUserActivityChannel = (itinerariesItem: IProposal) => {
  const { itemType, showChangesDetectedModal, activeUsers, userConnected, handleChangesDetectedModal } =
    useItinerariesItemContext();
  const { isTabletOrMobile } = useMediaBreakpoints();

  useMultipleTabsModal(itinerariesItem?.id, userConnected);

  useEffect(() => {
    if (showChangesDetectedModal) {
      showModal<false>(area, (res) => (
        <ChangesDetectedModal
          onClose={() => {
            handleChangesDetectedModal(false);
            res(false);
          }}
        />
      ));
    }
  }, [showChangesDetectedModal]);

  const renderUserBubbles = () => (
    <>
      <UserBubbles activeUsers={activeUsers.slice().reverse() as User[]} itemType={itemType} />
      {!isTabletOrMobile && <div className={styles.divider} />}
    </>
  );

  return { renderUserBubbles };
};
